import ProposalClientTeamView from "work/proposals/_views/_shared/proposal-client-team-view";
import WorkAgreement from "work/work-agreements/work-agreement";

type ClientTeamTabProps = {
  workAgreement: WorkAgreement;
};

/**
 * Displays the immutable client participant roster captured by the hired work agreement.
 * Roster management remains on the active proposal while it is being negotiated.
 */
export default function ClientTeamTab({ workAgreement }: Readonly<ClientTeamTabProps>) {
  return <ProposalClientTeamView clientTeam={workAgreement.clientTeam ?? null} />;
}
